import React from 'react'
import PropTypes from 'prop-types'
import Shimmer from 'Components/shimmer'

const MaleDailyArticleCardTwoShimmer = ({ isMobile }) => {
  return (
    <>
      <div className="article-style-two-shimmer">
        <div className="article-style-two-shimmer__image">
          <Shimmer
            width={isMobile ? '156px' : '240px'}
            height={isMobile ? '156px' : '240px'}
          />
        </div>
        <div className="article-style-two-shimmer__text">
          <Shimmer width="88px" height="12px" />
          <div className="article-style-two-shimmer__title">
            <Shimmer width="100%" height="12px" />
            <Shimmer width="100%" height="12px" />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .article-style-two-shimmer {
            display: flex;
            flex-direction: column;
            gap: 12px;
            text-decoration: none;
          }

          .article-style-two-shimmer__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-two-shimmer__title {
            display: flex;
            flex-direction: column;
            width: 100%;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardTwoShimmer.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardTwoShimmer
